<template lang="pug">

div
  platform(v-if="alias=='platform'")
  other(v-else :alias="alias")

  home-try(:alias="alias") 

</template>


<script>
import platform from './content/Platform'
import other from './content/Other'
import homeTry from '../home/Try'

    export default {
        props: {
          alias: null
        },
        components: {
            platform,
            other,
            homeTry
        },
    }
</script>

